// Only use articles from the Articles folder with metadata
export const montrealPins = [
  {
    "id": "424-aqueduc",
    "title": "424 Aqueduc",
    "description": "424 Aqueduc was an independent recording studio and creative hub located in Montreal's Griffintown district. Founded in 2021 by Shawn Cote during the COVID-19 pandemic, the studio operated until 2023 when it was forced to close due to building demolition. Known for its cross-genre collaborative approach and deliberately anti-commercial aesthetic, the studio became a significant gathering place for Montreal's music community despite its brief operational period.",
    "lat": 45.49185237077064, 
    "lng": -73.56503025291049,
    "markdownFile": "Articles/424_Aqueduc.md",
    "category": "Musicians"
  },
  {
    "id": "a-trak",
    "title": "A-Trak",
    "description": "A-Trak (born Alain Macklovitch) is a DJ and producer. Raised in Outremont, he gained recognition as the 1997 DMC World Champion, a title he won at just 15 years old. A-Trak founded the label Fool's Gold and champions Montreal artists.",
    "lat": 45.5186167,
    "lng": -73.6068856,
    "markdownFile": "Articles/A-Trak.md",
    "category": "Musicians"
  },
  {
    "id": "airdutemps",
    "title": "Air du Temps",
    "description": "Air du Temps stood as a landmark venue in Montreal's jazz landscape. Situated in Old Montreal, the club provided an intimate setting where audiences could experience live jazz in a welcoming atmosphere.",
    "lat": 45.50287408228099, 
    "lng": -73.55534949496418,
    "markdownFile": "Articles/Air_Du_Temps.md",
    "category": "Venue"
  },
  {
    "id": "alien8-recordings",
    "title": "Alien8 Recordings",
    "description": "Alien8 Recordings was an independent record label founded in 1996 in Montreal by Sean O'Hara and Gary Worsley, specializing in experimental and noise music. Releasing albums from avant-garde artists like Merzbow and Tim Hecker, as well as The Unicorns' debut album, the label operated until 2011 and left a lasting impact on Montreal's underground music scene.",
    "lat": 45.51868023547531, 
    "lng": -73.5727879828472,
    "markdownFile": "Articles/Alien8_Recordings.md",
    "category": "Labels"
  },
  {
    "id": "also-cool-mag",
    "title": "Also Cool Magazine",
    "description": "Also Cool Magazine is a Montreal and Ottawa-based independent online arts and music publication. Operating as a volunteer-run digital magazine, podcast, and radio show, Also Cool documents and supports DIY music scenes across Eastern Canada.",
    "lat": 45.533095013178766,
    "lng": -73.60602116100303,
    "markdownFile": "Articles/Also_Cool_Mag.md",
    "category": "Media"
  },
  {
    "id": "arbutus-records",
    "title": "Arbutus Records",
    "description": "Arbutus Records is an independent record label based in Montreal, known for its diverse roster of artists and innovative approach to music production and distribution. The label has played a significant role in the development of the Montreal music scene, supporting both emerging and established artists.",
    "lat": 45.52586023161464,
    "lng": -73.61401836756384,
    "markdownFile": "Articles/Arbutus.md",
    "category": "Labels"
  },
  {
    "id": "arcade-fire",
    "title": "Arcade Fire",
    "description": "Arcade Fire is a Canadian indie rock band from Montreal that rose to prominence with their critically acclaimed 2004 debut album \"Funeral.\" The band, led by Win Butler and Régine Chassagne, won the Grammy Award for Album of the Year in 2011 for \"The Suburbs\" and has become one of the most influential indie rock acts of the 21st century.",
    "lat": 45.52752643335335, 
    "lng": -73.60707057934728,
    "markdownFile": "Articles/Arcade_Fire.md",
    "category": "Musicians"
  },
  {
    "id": "audiogram",
    "title": "Audiogram",
    "description": "Audiogram is an independent record label founded in Quebec in 1984, specializing in artists who have significantly contributed to Quebec's cultural music scene. Featuring notable musicians like Daniel Bélanger, Lhasa de Sela, and Pierre Lapointe, the label was acquired by Quebecor in 2021, cementing its importance in Quebec's music industry.",
    "lat": 45.5007494854932, 
    "lng": -73.55993586012973,
    "markdownFile": "Articles/Audiogram.md",
    "category": "Labels"
  },
  {
    "id": "ausgang-plaza",
    "title": "Ausgang Plaza",
    "description": "Ausgang Plaza is a non-profit organization that promotes and produces initiatives that encourage local culture, with a cosmopolitan offering. The site has a 4,500 sq. feet multidisciplinary space, a pop-up space and gallery, in addition to housing several organizations active in the cultural industry.",
    "lat": 45.53631555328398,
    "lng": -73.60390319093737,
    "markdownFile": "Articles/Ausgang_Plaza.md",
    "category": "Venue"
  },
  {
    "id": "backxwash",
    "title": "Backxwash",
    "description": "Backxwash is a Montreal-based rapper and producer known for her unique blend of hip-hop, industrial, and metal influences. She gained recognition for her powerful lyrics and innovative sound, winning the Juno Award for Rap Album of the Year in 2021.",
    "lat": 45.52347628003525,
    "lng": -73.58306831688485,
    "markdownFile": "Articles/Backxwash.md",
    "category": "Musicians"
  },
  {
    "id": "banx-and-ranx",
    "title": "Banx & Ranx",
    "description": "Banx & Ranx is a Montreal-based music production duo formed in 2014, comprising Zacharie \"Soké\" Raymond and Yannick \"KNY Factory\" Rastogi. Known for their signature ECM (Electronic Caribbean Music) sound blending reggae, dancehall, and electronic music with pop sensibilities, they have become one of Canada's most successful producer-songwriter teams with a Grammy nomination and Juno Award win.",
    "lat": 45.54369267748304,
    "lng": -73.59743412342665,
    "markdownFile": "Articles/Banx_and_Ranx.md",
    "category": "Musicians"
  },
  {
    "id": "biddles-jazz-and-ribs",
    "title": "Biddles Jazz and Ribs",
    "description": "Biddles Jazz and Ribs was a renowned jazz club in Montreal, founded in 1981 by George Durst and bassist Charlie Biddle. Located on Aylmer Street, the club was a significant launching pad for many local jazz musicians, including Oliver Jones.",
    "lat": 45.505641393671816,
    "lng": -73.57181655198235,
    "markdownFile": "Articles/Biddles_Jazz_and_Ribs.md",
    "category": "Musicians"
  },
  {
    "id": "bonsound",
    "title": "Bonsound",
    "description": "Bonsound is a multifaceted music company founded in October 2004 in Montreal by Jean-Christian Aubry, Gourmet Délice, and Yanick Masse, operating as an artist management company, record label, booking agency, and concert promoter. Winning multiple L'ADISQ awards for \"management company of the year,\" it represents diverse Quebec artists including Pierre Kwenders, Lisa LeBlanc, and Corridor.",
    "lat": 45.52702829533206, 
    "lng": -73.59731638445314,
    "markdownFile": "Articles/Bonsound.md",
    "category": "Labels"
  },
  {
    "id": "breakglass-studios",
    "title": "Breakglass Studios",
    "description": "Breakglass Studios is an independent recording studio located in Montreal, Quebec, founded in 2000 by Jace Lasek, Dave Smith, Olga Goreas, and Mike Gardner. Known for its DIY ethos and contributions to Montreal's indie rock scene, the studio has recorded numerous notable Canadian artists while maintaining an accessible, artist-focused approach.",
    "lat": 45.53454048603067,
    "lng": -73.62015824056708,
    "markdownFile": "Articles/Breakglass_Studios.md",
    "category": "Studio"
  },
  {
    "id": "cafe-campus",
    "title": "Café Campus",
    "description": "Café Campus, founded in 1967 by the University of Montreal student association, has been a cornerstone of Montreal's music scene for over five decades. Operating as a worker cooperative with two performance spaces, it launched the careers of Quebec legends like Félix Leclerc, Robert Charlebois, and Harmonium.",
    "lat": 45.51452472374804, 
    "lng": -73.57231764172126,
    "markdownFile": "Articles/Cafe_Campus.md",
    "category": "Venues"
  },
  {
    "id": "casa-del-popolo",
    "title": "Casa del Popolo",
    "description": "Casa del Popolo is a multifaceted bar, bistro, and music venue established in 2000 in Montreal's Le Plateau-Mont-Royal neighborhood. Described by Fodor's as \"one of Montreal's top venues for indie rock music\" and compared to the legendary CBGB, it has hosted notable acts like Arcade Fire and Buck 65, while serving as a community-oriented cultural hub.",
    "lat": 45.522170766281675, 
    "lng": -73.59053726665807,
    "markdownFile": "Articles/Casa_del_Popolo.md",
    "category": "Venues"
  },
  {
    "id": "celine-dion",
    "title": "Céline Dion",
    "description": "Céline Dion is a Quebec-born international pop icon, recognized as one of the best-selling music artists of all time with over 200 million records sold worldwide. Her powerful vocals and emotionally charged ballads, including the iconic \"My Heart Will Go On,\" have earned her five Grammy Awards and global superstardom.",
    "lat": 45.60989518347318, 
    "lng": -73.79936223331663,
    "markdownFile": "Articles/Celine_Dion.md",
    "category": "Musicians"
  },
  {
    "id": "charlie-biddle",
    "title": "Charlie Biddle",
    "description": "Charles \"Charlie\" Biddle (1926–2003) was an influential American-Canadian jazz bassist and promoter. A driving force behind early jazz festivals, his efforts contributed to the creation of the Montreal International Jazz Festival. He later owned Biddle's Jazz Club (House of Jazz).Biddle has been recognized with honors like the Order of Canada.",
    "lat": 45.5038147277841,
    "lng": -73.55772114415875,
    "markdownFile": "Articles/Charlie_Biddle.md",
    "category": "Musicians"
  },
  {
    "id": "charlotte-cardin",
    "title": "Charlotte Cardin",
    "description": "Charlotte Cardin is a Montreal-based singer-songwriter known for her unique blend of pop, jazz, and electronic music. With a powerful voice and introspective lyrics, she has gained recognition in the Canadian music scene and has been nominated for several awards, including the Juno Awards.",
    "lat": 45.514135993399314, 
    "lng": -73.64415131444797,
    "markdownFile": "Articles/Charlotte_Cardin.md",
    "category": "Musicians"
  },
  {
    "id": "chromeo",
    "title": "Chromeo",
    "description": "Chromeo is a Montreal electro-funk duo formed in 2002 by Dave 1 and P-Thugg, who met at Collège Stanislas in the mid-1990s. Known for their infectious blend of synth-pop, funk, and disco, the band has released six studio albums and received a Grammy nomination for their 2018 album \"Head over Heels.\"",
    "lat": 45.5185056520686, 
    "lng": -73.6156989904422,
    "markdownFile": "Articles/Chromeo.md",
    "category": "Musicians"
  },
  {
    "id": "cism-fm",
    "title": "CISM-FM",
    "description": "CISM-FM (89.3 FM) is the official campus radio station of the Université de Montréal, established in 1991 and recognized as \"the world's largest French-language college radio station.\" Broadcasting with a 10,000-watt signal across Greater Montreal, the student-run station features exclusively French programming plus a Tamil language subsidiary channel, embodying an innovative, boundary-pushing approach to radio.",
    "lat": 45.50713880639483, 
    "lng": -73.61451456438809,
    "markdownFile": "Articles/CISM-FM.md",
    "category": "Media"
  },
  {
    "id": "ckut-fm",
    "title": "CKUT-FM",
    "description": "CKUT-FM (90.3 FM) is a non-profit, member-operated campus and community radio station broadcasting from McGill University since 1987, with a philosophy of being a \"mic for the mic-less.\" Featuring over 30 diverse shows covering genres from reggae to Korean culture, the station operates 24/7 and serves as a crucial platform for marginalized communities and independent media in Montreal.",
    "lat": 45.508044844890584, 
    "lng": -73.57950489297802,
    "markdownFile": "Articles/CKUT-FM.md",
    "category": "Media"
  },
  {
    "id": "club-soda",
    "title": "Club Soda",
    "description": "Club Soda is a prominent Montreal music venue established in 1982, currently located in the Quartier des Spectacles on Saint Laurent Boulevard. Originally situated on Park Avenue, the venue has been a cornerstone of Montreal's music scene for over four decades, hosting diverse musical acts in its historic 1908 building.",
    "lat": 45.50976748415593, 
    "lng": -73.56332404432165,
    "markdownFile": "Articles/Club_Soda.md",
    "category": "Venues"
  },
  {
    "id": "constellation-records",
    "title": "Constellation Records",
    "description": "Constellation Records is an independent record label founded in Montreal, Quebec, in 1997 by **Don Wilkie** and **Ian Ilavsky**. Known for its anti-capitalist ethos, artist-centric model, and focus on experimental, post-rock, and avant-garde music, the label has played a pivotal role in shaping Montreal's underground music scene and fostering artists like **Godspeed You\\! Black Emperor**, **Silver Mt. Zion**, and **Fly Pan Am**.",
    "lat": 0,
    "lng": 0,
    "markdownFile": "Articles/Constellation Records.md",
    "category": "Label"
  },
  {
    "id": "cult-mtl",
    "title": "Cult MTL",
    "description": "Cult MTL is an English-language arts, culture, and news publication founded in Montreal on September 7, 2012 by former Montreal Mirror editors including owner/editor-in-chief Lorraine Carpenter. Operating as both a monthly print publication and online platform, it emerged as a progressive voice filling the void left by the Mirror's closure.",
    "lat": 45.52603754520773, 
    "lng": -73.62115165886155,
    "markdownFile": "Articles/Cult_MTL.md",
    "category": "Media"
  },
  {
    "id": "divan-orange",
    "title": "Divan Orange",
    "description": "Divan Orange was a beloved Montreal music venue that operated as a worker cooperative from 2004 to 2018, dedicated to showcasing emerging talent. Hosting over 700 concerts annually in its intimate 150-person space, it won GAMIQ's Best Concert Venue award eight times and earned international recognition including mention in the New York Times.",
    "lat": 45.518249938019785, 
    "lng": -73.58251344358344,
    "markdownFile": "Articles/Divan_Orange.md",
    "category": "Venues"
  },
  {
    "id": "fantom",
    "title": "FATOM",
    "description": "FANTOM is a Montreal-based not-for-profit organization founded in 2022 to address systemic issues—such as violence, harassment, and exploitation—faced by queer, trans, BIPOC, and ally nightlife communities.",
    "lat": 45.51225112916636,
    "lng": -73.5554767136338,
    "markdownFile": "Articles/FANTOM.md",
    "category": "Collective"
  },
  {
    "id": "foufounes-electriques",
    "title": "Foufounes Électriques",
    "description": "Les Foufounes Électriques is an iconic underground music venue founded in 1983, a pivotal space for Montreal's punk and alternative culture. This multi-floor venue on Sainte-Catherine Street has hosted legendary acts like Nirvana and Smashing Pumpkins before their mainstream success, while nurturing Quebec's alternative music scene and evolving into a dynamic cultural institution.",
    "lat": 45.51098959566793, 
    "lng": -73.56308675325575,
    "markdownFile": "Articles/Foufounes_Electriques.md",
    "category": "Venues"
  },
  {
    "id": "godspeed-you-black-emperor",
    "title": "Godspeed You! Black Emperor",
    "description": "Godspeed You! Black Emperor is a Canadian post-rock collective formed in Montreal in 1994, known for their lengthy, instrumental compositions and politically charged performances. The band won the 2013 Polaris Music Prize for \"'Allelujah! Don't Bend! Ascend!\" and is considered one of the most influential acts in the post-rock genre.",
    "lat": 45.52749627773254, 
    "lng": -73.6069963320136,
    "markdownFile": "Articles/Godspeed_You_Black_Emperor.md",
    "category": "Musicians"
  },
  {
    "id": "grimes",
    "title": "Grimes",
    "description": "Grimes is a Canadian musician, singer, songwriter, and record producer who developed her distinctive experimental pop sound during her formative years in Montreal. Her breakthrough album \"Visions\" was created during an intense three-week period in her Mile End apartment, establishing her as one of the most innovative artists to emerge from Montreal's indie scene.",
    "lat": 45.52598164946762, 
    "lng": -73.61456612371393,
    "markdownFile": "Articles/Grimes.md",
    "category": "Musicians"
  },
  {
    "id": "half-moon-run",
    "title": "Half Moon Run",
    "description": "Half Moon Run is a Canadian indie rock band formed in Montreal's Mile End neighborhood in 2009, known for their layered percussion, three-part vocal harmonies, and multi-instrumental live performances. Their debut album \"Dark Eyes\" launched them onto the international stage, and they won a Juno Award for their 2019 album \"A Blemish in the Great Light.\"",
    "lat": 45.5094395673558, 
    "lng": -73.56688668968219,
    "markdownFile": "Articles/Half_Moon_Run.md",
    "category": "Musicians"
  },
  {
    "id": "heavy-montreal",
    "title": "Heavy Montréal",
    "description": "Heavy Montréal (formerly Heavy MTL) was an annual two-day heavy metal and hard rock music festival held at Parc Jean-Drapeau from 2008 to 2019. The festival featured major acts like Iron Maiden, Metallica, and Slayer, and briefly expanded to Toronto before ceasing operations in 2020.",
    "lat": 45.51382002354062, 
    "lng": -73.5337427291434,
    "markdownFile": "Articles/Heavy_Montreal.md",
    "category": "Events"
  },
  {
    "id": "homegrown-harvest",
    "title": "Homegrown Harvest",
    "description": "Homegrown Harvest is a Montreal-based event collective founded in 2015 that organizes underground parties to support local talent and develop the city's electronic music scene.",
    "lat": 0,
    "lng": 0,
    "markdownFile": "Articles/Homegrown_Harvest.md",
    "category": "Events"
  },
  {
    "id": "hotel2tango",
    "title": "hotel2tango",
    "description": "hotel2tango is a 24-track analog recording studio located in Montreal's Mile End district. The facility, which opened in its current location in 2007, operates as both a recording studio and cultural hub, housing Constellation Records and Grey Market Mastering under the same roof. Known for its commitment to analog recording and its documentary-style approach to capturing live performances, the studio has become synonymous with Montreal's independent music scene.",
    "lat": 0,
    "lng": 0,
    "markdownFile": "Articles/hotel2tango.md",
    "category": "Studio"
  },
  {
    "id": "hot-tramp",
    "title": "Hot Tramp",
    "description": "Hot Tramp is a Montreal-based independent music label, artist management company, and creative services agency founded in 2019. Initially launched as a management and promotion company, Hot Tramp pivoted to include a record label during the COVID-19 pandemic. Named after a David Bowie lyric, the company focuses exclusively on supporting women and non-binary artists.",
    "lat": 45.47975900710809,
    "lng": -73.5810003654244,
    "markdownFile": "Articles/Hot_Tramp.md",
    "category": "Label"
  },
  {
    "id": "igloofest",
    "title": "Igloofest",
    "description": "Igloofest is an annual outdoor winter electronic music festival held at Montreal's Old Port since January 2007. Co-produced by Piknic Électronik, the festival draws tens of thousands of attendees who brave the cold for performances by international DJs like Diplo, Carl Cox, and Kaytranada, featuring a playful \"One-Piece\" snowsuit contest.",
    "lat": 45.508602355850726, 
    "lng": -73.55214338427969,
    "markdownFile": "Articles/Igloofest.md",
    "category": "Events"
  },
  {
    "id": "kaytranada",
    "title": "Kaytranada",
    "description": "Kaytranada is a Haitian-Canadian DJ, producer, and Grammy-winning artist known for blending electronic, hip-hop, R&B, and dance music.",
    "lat": 45.5033611221686,
    "lng": -73.42954433890658,
    "markdownFile": "Articles/Kaytranada.md",
    "category": "Musicians"
  },
  {
    "id": "lecypher",
    "title": "LeCypher X",
    "description": "LeCypher X is a weekly Montreal hip-hop jam session founded in October 2014 by saxophonist Vincent Stephen-Ong. Bringing together MCs and live musicians for improvised performances every Thursday at O Patro Vys, the event has become a cornerstone of Montreal's hip-hop community.",
    "lat": 45.52343912836317,
    "lng": -73.5832258252407,
    "markdownFile": "Articles/LeCypher.md",
    "category": "Collective"
  },
  {
    "id": "the-lime-light",
    "title": "The Lime Light",
    "description": "The Lime Light club was the epicenter of Montreal's disco scene from its founding in 1973 by Yvon Lafrance and co-owner François Mireault, until its closure in 1990. During the 1970s and early 1980s, Montreal was recognized as the second most important disco capital in North America behind New York, with the Lime Light even rivaling the legendary Studio 54 in Manhattan.",
    "lat": 45.49894608957035,
    "lng": -73.57297320838829,
    "markdownFile": "Articles/The_Lime_Light.md",
    "category": "Venues"
  },
  {
    "id": "la-tulipe",
    "title": "La Tulipe",
    "description": "La Tulipe is a historic Montreal performance venue built between 1913-1919, originally serving as a cinema before being transformed by comedian Gilles Latulippe into the Théâtre des Variétés in 1967. Renamed in 2004 to honor Latulippe, this classified heritage building has hosted rock, jazz, and francophone music, though recent court rulings have threatened its future.",
    "lat": 45.53312288859642, 
    "lng": -73.57535060112492,
    "markdownFile": "Articles/La_Tulipe.md",
    "category": "Venues"
  },
  {
    "id": "leonard-cohen",
    "title": "Leonard Cohen",
    "description": "Leonard Cohen was a Canadian singer-songwriter, poet, and novelist, widely regarded as one of the most influential lyricists in popular music. His poetic songs exploring themes of love, faith, and mortality, including the iconic \"Hallelujah,\" earned him induction into the Rock and Roll Hall of Fame and recognition as a Companion of the Order of Canada.",
    "lat": 45.497421387291666, 
    "lng": -73.57653742141056,
    "markdownFile": "Articles/Leonard_Cohen.md",
    "category": "Musicians"
  },
  {
    "id": "lunice",
    "title": "Lunice",
    "description": "Lunice is a Montreal-born electronic music producer and DJ, best known as one half of the duo TNGHT with Hudson Mohawke. His innovative trap and electronic productions have influenced contemporary hip-hop and electronic music, with collaborations including Azealia Banks and work for major artists worldwide.",
    "lat": 0,
    "lng": 0,
    "markdownFile": "Articles/Lunice.md",
    "category": "Musicians"
  },
  {
    "id": "mardemarco",
    "title": "Mac DeMarco",
    "description": "Mac DeMarco is a Canadian singer-songwriter and multi-instrumentalist known for his laid-back style and unique sound, blending elements of rock, pop, and jazz. He gained fame with albums like \"2\" and \"Salad Days,\" and is recognized for his charismatic live performances.",
    "lat": 45.52691782720206,
    "lng": -73.61285463831838,
    "markdownFile": "Articles/Mac_DeMarco.md",
    "category": "Musicians"
  },
  {
    "id": "m-for-montreal",
    "title": "M for Montreal",
    "description": "M for Montreal is an annual 4-day music industry event founded in 2006 to help Quebec and Canadian artists export their music internationally. Featuring approximately 100 bands, conference programming, and over 200 international music industry delegates, it has showcased artists like Mac DeMarco, Grimes, and Patrick Watson.",
    "lat": 45.52580043873195, 
    "lng": -73.59914140784107,
    "markdownFile": "Articles/M_for_Montreal.md",
    "category": "Events"
  },
  {
    "id": "men-i-trust",
    "title": "Men I Trust",
    "description": "Men I Trust is a Canadian indie/dream pop band formed in Quebec City in 2014, consisting of Emmanuelle Proulx (vocals/guitar), Jessy Caron (guitar/bass), and Dragos Chiriac (keyboards).The band has found a worldwide cult following, while remaining fully independent.",
    "lat": 45.48285397445844,
    "lng": -73.57509310681235,
    "markdownFile": "Articles/Men_I_Trust.md",
    "category": "Musicians"
  },
  {
    "id": "metropolis",
    "title": "Métropolis",
    "description": "Métropolis (now M Telus) is a 2,350-capacity performing arts venue in Montreal's Quartier des Spectacles, housed in a historic building dating to 1884. Originally a skating rink, then cinema and disco, it has hosted legendary performers including David Bowie, Radiohead, and Björk, and serves as a key venue for the Montreal International Jazz Festival.",
    "lat": 45.51061663375332, 
    "lng": -73.5633687749146,
    "markdownFile": "Articles/Metropolis.md",
    "category": "Venues"
  },
  {
    "id": "montreal-international-jazz-festival",
    "title": "Montreal International Jazz Festival",
    "description": "The Montreal International Jazz Festival, founded in 1980, holds the Guinness World Record as the world's largest jazz festival. Featuring approximately 3,000 artists from 30 countries, over 650 concerts (including 450 free outdoor performances), and attracting more than 2 million visitors annually, it has become Montreal's signature cultural event.",
    "lat": 45.50752782550835, 
    "lng": -73.5672089145458,
    "markdownFile": "Articles/Montreal_International_Jazz_Festival.md",
    "category": "Events"
  },
  {
    "id": "montreal-jubilation",
    "title": "Montreal Jubilation Gospel Choir",
    "description": "The Montreal Jubilation Gospel Choir (MJGC), founded in 1974 by Trevor W. Payne and Daisy Peterson Sweeney as the Montreal Black Community Youth Choir, evolved into a world-renowned ensemble known for its dynamic performances and acclaimed recordings.",
    "lat": 45.48236752393602,
    "lng": -73.57907444057305,
    "markdownFile": "Articles/Montreal_Jubilation.md",
    "category": "Musicians"
  },
  {
    "id": "moonshine",
    "title": "Moonshine",
    "description": "Moonshine is a Montreal-based artist collective founded in 2014 that spotlights contemporary African and Afro-diasporic sounds through late-night club events, a music label, and an apparel brand. Starting as monthly warehouse parties after each full moon, the collective has expanded internationally to cities like Paris and Los Angeles, earning Juno Award nominations while reshaping Montreal's nightlife.",
    "lat": 45.52769956418807, 
    "lng": -73.6077953242735,
    "markdownFile": "Articles/Moonshine.md",
    "category": "Collectives"
  },
  {
    "id": "mothland",
    "title": "Mothland",
    "description": "Mothland is a Montreal-based independent label, booking agency, and festival producer that has become central to the city's underground music scene since 2017. The collective emerged from the DIY psychedelic festival Distortion and transformed during the pandemic into one of Canada's most adventurous independent labels.",
    "lat": 45.53880343921317,
    "lng": -73.58540579734789,
    "markdownFile": "Articles/Mothland.md",
    "category": "Label"
  },
  {
    "id": "mutek",
    "title": "MUTEK",
    "description": "MUTEK is a Montreal-based festival that synthesizes the world of electronic music with digital art. Conceived in 2000 by Alain Mongeau, the festival has achieved international renown for filling the gap between music and live audiovisual performances, highlighting the intersection between culture and technology.",
    "lat": 45.509526731102476,
    "lng": -73.56280483428894,
    "markdownFile": "Articles/MUTEK.md",
    "category": "Festival"
  },
  {
    "id": "myron-sutton",
    "title": "Myron Sutton",
    "description": "Myron \"Mynie\" Sutton was a Canadian jazz saxophonist and bandleader who led the Canadian Ambassadors, one of the first black jazz bands in Canada. Active in Montreal's jazz scene during the 1930s, he performed at legendary venues like Connie's Inn and Cafe Montmartre, playing a crucial role in the city's early jazz history.",
    "lat": 45.51022892097714, 
    "lng": -73.56422549055549,
    "markdownFile": "Articles/Myron_Sutton.md",
    "category": "Musicians"
  },
  {
    "id": "nate-husser",
    "title": "Nate Husser",
    "description": "Nate Husser is a Montreal-based rapper and member of the hip-hop collective Dead Obies. Known for his introspective lyrics and unique sound, he has gained recognition in the Canadian music scene and has collaborated with various artists across genres.",
    "lat": 45.48896794812417, 
    "lng": -73.57478852518317,
    "markdownFile": "Articles/Nate_Husser.md",
    "category": "Musicians"
  },
  {
    "id": "ncc",
    "title": "Negro Community Centre",
    "description": "The Negro Community Centre (NCC) is a cultural and community hub in Montreal that has played a vital role in supporting the city's Black community since its founding in 1944. The NCC offers a range of programs and services, including arts and cultural events, educational workshops, and social services, fostering a sense of belonging and empowerment.",
    "lat": 45.48865468847868,
    "lng": -73.57554360052306,
    "markdownFile": "Articles/Negro_Community_Centre.md",
    "category": "Notable Places"
  },
  {
    "id": "nelson-symonds",
    "title": "Nelson Symonds",
    "description": "Nelson Symonds was a Canadian jazz guitarist who became a fixture of Montreal's jazz scene for over 40 years after settling in the city in 1958. Praised by legends like John Coltrane and Wes Montgomery, he won the Oscar Peterson prize in 1996 for his contribution to jazz and performed at iconic Montreal venues including Rockhead's Paradise and the Black Bottom.",
    "lat": 45.494627750617035,
    "lng": -73.56947012303087,
    "markdownFile": "Articles/Nelson_Symonds.md",
    "category": "Musicians"
  },
  {
    "id": "nomad",
    "title": "Nomad",
    "description": "Nomad was established on May 1, 2010, when Jason Rodi acquired a building by the train tracks of the Montreal Mile End. Initially intended as a production studio and co-working space for filmmakers and creatives, the venue quickly evolved into an event space due to high demand from local artists. Known for hosting diverse events, pioneering live-streaming projects, and nurturing influential cultural movements like Moonshine and Art Jam, Nomad became a cornerstone of Montreal's DIY arts scene.",
    "lat": 45.52768614742999,
    "lng": -73.60793867777494,
    "markdownFile": "Articles/Nomad.md",
    "category": "Venue"
  },
  {
    "id": "nomadic-massive",
    "title": "Nomadic Massive",
    "description": "Nomadic Massive is a groundbreaking Montreal hip-hop collective founded in 2004, renowned for their multicultural and multilingual musical approach spanning English, French, Haitian Creole, Spanish, Swahili, and Arabic. With performances at prestigious international festivals and albums that address social themes, they serve as cultural ambassadors representing Montreal's diverse hip-hop scene.",
    "lat": 45.521815501585706, 
    "lng": -73.59052436669215,
    "markdownFile": "Articles/Nomadic_Massive.md",
    "category": "Collectives"
  },
  {
    "id": "parc-jean-drapeau",
    "title": "Parc Jean-Drapeau",
    "description": "Parc Jean-Drapeau is Montreal's third-largest park, comprising Saint Helen's Island and the artificial Notre Dame Island in the Saint Lawrence River. Site of Expo 67 and renamed in 1999 to honor Mayor Jean Drapeau, it now hosts major festivals including Osheaga, Heavy Montréal, and Piknic Électronik, as well as La Ronde amusement park and the Montreal Casino.",
    "lat": 45.511190000824286,
    "lng": -73.53563969807712,
    "markdownFile": "Articles/Parc_Jean-Drapeau.md",
    "category": "Collectives"
  },
  {
    "id": "place-des-arts",
    "title": "Place des Arts",
    "description": "Place des Arts is a major performing arts complex in Montreal, home to several theaters and concert halls, including the Salle Wilfrid-Pelletier, the largest venue in the complex. It hosts a wide range of cultural events, including concerts, theater productions, and dance performances, making it a central hub for the arts in the city.",
    "lat": 45.5016889,
    "lng": -73.5732025,
    "markdownFile": "Articles/Place_des_Arts.md",
    "category": "Collectives"
  },
  {
    "id": "oliver-jones",
    "title": "Oliver Jones",
    "description": "Oliver Jones is a Canadian jazz piano virtuoso whose dazzling technique and swinging style earned him comparisons to his childhood friend and mentor, Oscar Peterson. An Officer of the Order of Canada and Knight of the Ordre national du Québec, Jones was inducted into the Canadian Music Hall of Fame in 2023.",
    "lat": 45.48665149274073,
    "lng": -73.57343324970324,
    "markdownFile": "Articles/Oliver_Jones.md",
    "category": "Musicians"
  },
  {
    "id": "oscar-peterson",
    "title": "Oscar Peterson",
    "description": "Oscar Peterson was a Canadian jazz piano virtuoso and composer, widely regarded as one of the greatest jazz pianists of all time. He led iconic trios, most notably with bassist Ray Brown and guitarist Herb Ellis, and recorded over 200 albums, winning eight Grammy Awards, including a Lifetime Achievement Award. His prolific career spanned six decades, blending swing, bebop, and classical influences into a signature style marked by breathtaking speed and harmonic richness.",
    "lat": 45.48939240379392,
    "lng": -73.57219640062199,
    "markdownFile": "Articles/Oscar_Peterson.md",
    "category": "Musicians"
  },
  {
    "id": "osheaga",
    "title": "Osheaga Music and Arts Festival",
    "description": "Osheaga is Montreal's premier multi-day rock and indie music festival, launched in 2006 at Parc Jean-Drapeau. Named after the Indigenous term for the Montreal region, the festival attracts 155,000 attendees annually and features approximately 100 bands across six stages, hosting major international headliners and emerging artists.",
    "lat": 45.511190000824286, 
    "lng": -73.53563969807712,
    "markdownFile": "Articles/Osheaga.md",
    "category": "Events"
  },
  {
    "id": "patrick-watson",
    "title": "Patrick Watson",
    "description": "Patrick Watson is a Canadian singer-songwriter from Montreal known for his blend of cabaret pop, classical music influences, and indie rock. He won the 2007 Polaris Music Prize for \"Close to Paradise\" and achieved historic success with \"Je te laisserai des mots,\" the first French-language song to reach 1 billion streams on Spotify.",
    "lat": 45.514544517174166, 
    "lng": -73.67536019567358,
    "markdownFile": "Articles/Patrick_Watson.md",
    "category": "Musicians"
  },
  {
    "id": "bad-news-brown",
    "title": "Paul Frappier",
    "description": "Paul Frappier (May 8, 1977 – February 11, 2011), better known by his stage name Bad News Brown, was a pioneering Montreal-based hip-hop artist of Haitian origin. He was renowned for his unique style of combining blues harmonica playing with hip-hop beats and rhymes.",
    "lat": 45.50982198376032,
    "lng": -73.56453209510799,
    "markdownFile": "Articles/Bad_News_Brown.md",
    "category": "Musicians"
  },
  {
    "id": "piknic-electronik",
    "title": "Piknic Électronik",
    "description": "Piknic Électronik is a weekly electronic music festival that has been a Montreal summer tradition since 2003, held every Sunday at Parc Jean-Drapeau. Featuring local and international DJs and attracting 178,000 attendees in 2022, it includes family-friendly Petit Piknic programming and has expanded internationally to Barcelona, Melbourne, Dubai, and other cities.",
    "lat": 45.51225357618414, 
    "lng": -73.53702742102492,
    "markdownFile": "Articles/Piknic_Electronik.md",
    "category": "Events"
  },
  {
    "id": "plants-and-animals",
    "title": "Plants and Animals",
    "description": "Plants and Animals is a Canadian indie rock trio from Montreal, featuring members originally from Nova Scotia who began playing together as children. Their debut album \"Parc Avenue\" (2008) was shortlisted for the Polaris Music Prize and nominated for a Juno Award, establishing them as a distinctive voice in Canadian indie rock.",
    "lat": 45.52591452558566, 
    "lng": -73.61057448465151,
    "markdownFile": "Articles/Plants_and_Animals.md",
    "category": "Musicians"
  },
  {
    "id": "pop-montreal",
    "title": "POP Montreal",
    "description": "POP Montreal is an annual independent music festival founded in 2002, showcasing over 400 bands in more than 50 venues across the city, primarily in the Mile End neighborhood. The festival has launched artists like Arcade Fire and Grimes and incorporates music-related film, art, conferences, and markets into a comprehensive celebration of indie culture.",
    "lat": 45.52011539635275, 
    "lng": -73.58637137065443,
    "markdownFile": "Articles/POP_Montreal.md",
    "category": "Events"
  },
  {
    "id": "ranee-lee",
    "title": "Ranee Lee",
    "description": "Ranee Lee, CM, known as \"Montreal's Queen of Jazz,\" is an American-born jazz vocalist, multi-instrumentalist, actress, and educator who has been a cornerstone of Canada's jazz scene since moving to Montreal in 1970.",
    "lat": 45.4679674,
    "lng": -73.6289223,
    "markdownFile": "Articles/Ranee Lee.md",
    "category": "Musicians"
  },
  {
    "id": "rockheads-paradise",
    "title": "Rockhead's Paradise",
    "description": "Rockhead's Paradise, founded by Jamaican-born Rufus Rockhead in 1931 in the Little Burgundy neighborhood, holds the distinction of being the city's first nightclub owned by a Black businessman. For decades, it hosted icons like Louis Armstrong, Ella Fitzgerald, and Duke Ellington, while also serving as a crucial incubator for homegrown talent, including a young Oscar Peterson, and directly inspiring future club owners like Charles Burke of the Black Bottom.",
    "lat": 45.4952339411202,
    "lng": -73.56876427536213,
    "markdownFile": "Articles/Rockheads_Paradise.md",
    "category": "Venues"
  },
  {
    "id": "rufus-wainwright",
    "title": "Rufus Wainwright",
    "description": "Rufus Wainwright is a Canadian-American singer-songwriter and composer known for his baroque pop style and operatic compositions. The son of folk musicians Kate McGarrigle and Loudon Wainwright III, he has released eleven studio albums and composed two operas, winning multiple Juno Awards.",
    "lat": 45.53089859774164, 
    "lng": -73.61032985612434,
    "markdownFile": "Articles/Rufus_Wainwright.md",
    "category": "Musicians"
  },
  {
    "id": "sam-roberts",
    "title": "Sam Roberts",
    "description": "Sam Roberts is a Canadian rock singer-songwriter who has released seven albums and won six Juno Awards, including Artist of the Year twice. His breakthrough album \"We Were Born in a Flame\" achieved double platinum status in Canada and established him as a prominent figure in Canadian indie rock.",
    "lat": 45.47210295423115, 
    "lng": -73.79877375956968,
    "markdownFile": "Articles/Sam_Roberts.md",
    "category": "Musicians"
  },
  {
    "id": "samuel-gesser",
    "title": "Samuel Gesser",
    "description": "Samuel Gesser (1930-2008) was a Canadian impresario, record producer, and writer from Montreal who recorded approximately 100 discs of Canadian folk music for Folkways Records, working with artists like Leonard Cohen and Jean Carignan. He produced concerts for Harry Belafonte, Pete Seeger, and Joan Baez, and headed entertainment for Expo 67, receiving the Order of Canada in 1993.",
    "lat": 45.49604437523685, 
    "lng": -73.58517935655915,
    "markdownFile": "Articles/Samuel_Gesser.md",
    "category": "Notable Figures"
  },
  {
    "id": "secret-city-records",
    "title": "Secret City Records",
    "description": "Secret City Records is an independent Canadian record label founded in 2006 by Andrew Rose and Justin West in Montreal. Originally a sublabel of Justin Time Records before becoming fully independent in 2008, it champions notable indie artists including Patrick Watson, Plants and Animals, and The Barr Brothers, with multiple Polaris Music Prize nominations and wins.",
    "lat": 45.53701151766436, 
    "lng": -73.62421049258886,
    "markdownFile": "Articles/Secret_City_Records.md",
    "category": "Labels"
  },
  {
    "id": "simple-plan",
    "title": "Simple Plan",
    "description": "Simple Plan is a Canadian pop-punk band formed in Montreal in 1999, known for their energetic performances and anthemic songs. The band achieved international success with albums like \"No Pads, No Helmets...Just Balls\" and has raised nearly $3 million through their charitable Simple Plan Foundation.",
    "lat": 0,
    "lng": 0,
    "markdownFile": "Articles/Simple_Plan.md",
    "category": "Musicians"
  },
  {
    "id": "black-bottom-1",
    "title": "The Black Bottom",
    "description": "The Black Bottom was a legendary and foundational jazz club that was a cornerstone of Montreal's music scene from 1957 to 1976. Originally opened by Charlie Burke in Little Burgundy, the club eventually saw it hosting jazz titans like Miles Davis, Thelonious Monk, and Art Blakey.",
    "lat": 45.494627750617035,
    "lng": -73.56947012303087,
    "markdownFile": "Articles/Black_Bottom.md",
    "category": "Venue"
  },
  {
    "id": "black-bottom-2",
    "title": "The Black Bottom",
    "description": "The Black Bottom was a legendary and foundational jazz club that was a cornerstone of Montreal's music scene from 1957 to 1976. Originally opened by Charlie Burke in Little Burgundy, the club eventually saw it hosting jazz titans like Miles Davis, Thelonious Monk, and Art Blakey.",
    "lat": 45.5058027741773,
    "lng": -73.5534276814747,
    "markdownFile": "Articles/Black_Bottom.md",
    "category": "Venue"
  },
  {
    "id": "the-dears",
    "title": "The Dears",
    "description": "The Dears are a Canadian indie rock band formed in Montreal in 1995, led by the husband-and-wife duo of Murray Lightburn and Natalia Yanchak. Known for their orchestral, dark pop sound and dramatic performances, the band has received multiple Polaris Music Prize nominations and has been a fixture of Montreal's indie rock scene for over two decades.",
    "lat": 45.51712043511955, 
    "lng": -73.58000807925782,
    "markdownFile": "Articles/The_Dears.md",
    "category": "Musicians"
  },
  {
    "id": "the-diving-bell",
    "title": "The Diving Bell",
    "description": "The Diving Bell Social Club was an independent music and performance venue located in the Plateau neighborhood of Montreal, Quebec. Known for its eclectic programming and community-driven ethos, the venue became a hub for emerging artists, experimental performances, and diverse cultural events during its operation from 2018 to its closure in December 2023. The Diving Bell was celebrated for its intimate atmosphere and DIY spirit.",
    "lat": 45.5165688,
    "lng": -73.5790441,
    "markdownFile": "Articles/The_Diving_Bell.md",
    "category": "Venue"
  },
  {
    "id": "the-spectrum",
    "title": "The Spectrum",
    "description": "The Spectrum was a historic Montreal concert venue that operated from 1952 to 2007, known for its unique cabaret-style setup with table service and distinctive wall of hundreds of lightbulbs. Over its 55-year history, it hosted countless performers, with Michel Rivard playing over 100 concerts there before closing as the final act.",
    "lat": 45.50638621860055, 
    "lng": -73.56667768017627,
    "markdownFile": "Articles/The_Spectrum.md",
    "category": "Venues"
  },
  {
    "id": "theatre-corona",
    "title": "Théâtre Corona",
    "description": "Théâtre Corona (now Beanfield Theatre) is a historic venue in Montreal's Little Burgundy neighborhood, built in 1912 as the Family Theatre for silent films. After decades of varied use including storage and filming, it was renovated and reopened in 1998 as a concert venue, becoming one of Montreal's preserved vintage theatres hosting live music.",
    "lat": 45.48286545077381, 
    "lng": -73.57508513862972,
    "markdownFile": "Articles/Theatre_Corona.md",
    "category": "Venues"
  },
  {
    "id": "theatre-fairmount",
    "title": "Théâtre Fairmount",
    "description": "Théâtre Fairmount is a significant music and performance venue in Montreal's Mile End neighborhood with a rich history dating back to 1983. Originally Club Soda and later Kola Note, the space was transformed by a cultural cooperative that hosted over 800 shows before reopening in 2015 as the Théâtre Fairmount, continuing its role as a vital cultural hub.",
    "lat": 45.52045726691408, 
    "lng": -73.59849190729173,
    "markdownFile": "Articles/Theatre_Fairmount.md",
    "category": "Venues"
  },
  {
    "id": "trevor-w-payne",
    "title": "Trevor W. Payne",
    "description": "Trevor W. Payne is a Barbadian-Canadian musician, conductor, and composer who became a driving force in Montreal's gospel and jazz scenes. Payne has been honored with the Order of Canada, the Thomas A. Dorsrey Gospel Music Award.",
    "lat": 45.482437594311264,
    "lng": -73.57932312711023,
    "markdownFile": "Articles/Trevor_W_Payne.md",
    "category": "Musicians"
  },
  {
    "id": "turbo-haus",
    "title": "Turbo Haüs",
    "description": "Turbo Haüs is a Montreal-based bar and music venue in the Quartier des Spectacles. Founded in 2013 as a DIY rehearsal space by Sergio Da Silva and his band Trigger Effect, it has evolved into a recognized venue hosting local and touring acts while navigating post-COVID challenges including noise bylaws, gentrification, and financial pressures.",
    "lat": 45.5160529,
    "lng": -73.5659204,
    "markdownFile": "Articles/Turbo_Haus.md",
    "category": "Venue"
  },
  {
    "id": "wolf-parade",
    "title": "Wolf Parade",
    "description": "Wolf Parade is a Canadian indie rock band formed in Montreal in 2003, known as a \"supergroup in reverse\" due to members' numerous successful side projects. Their debut album \"Apologies to the Queen Mary\" (2005) earned a Polaris Music Prize nomination and established them as a major force in Canadian indie rock.",
    "lat": 45.52176872708219,
    "lng": -73.5905647033786,
    "markdownFile": "Articles/Wolf_Parade.md",
    "category": "Musicians"
  },
  // Test pins for multi-pin functionality - same location as Casa del Popolo
  {
    "id": "test-pin-1",
    "title": "Test Venue - Event A",
    "description": "This is a test pin to demonstrate multi-pin functionality. Multiple artists performed at this venue on different dates.",
    "lat": 45.522170766281675,
    "lng": -73.59053726665807,
    "markdownFile": "Articles/Test_Pin_1.md",
    "category": "Event"
  },
  {
    "id": "test-pin-2",
    "title": "Test Venue - Event B",
    "description": "Another test pin at the same location to show how overlapping coordinates are handled.",
    "lat": 45.522170766281675,
    "lng": -73.59053726665807,
    "markdownFile": "Articles/Test_Pin_2.md",
    "category": "Event"
  },
  {
    "id": "test-pin-3",
    "title": "Test Venue - Event C",
    "description": "Third test pin at the same location to demonstrate badge count display.",
    "lat": 45.522170766281675,
    "lng": -73.59053726665807,
    "markdownFile": "Articles/Test_Pin_3.md",
    "category": "Event"
  }
];
